import React from "react";
import { parseStretch, parseRepeat } from "../../../model/millingStretch";

export default function MillingStretchOverlay({ stretchX, stretchY, repeatX, repeatY }) {
  return <svg viewBox="0 0 100 100" preserveAspectRatio="none" role="img"
    aria-label="Nyújtási helyek a képen"
    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none" }}>
    {[["x", stretchX, "#007bff"], ["y", stretchY, "#e56b00"]].map(([axis, spec, color]) => {
      const repetition = axis === "x" ? repeatX : repeatY;
      if (repetition) {
        let config;
        try { config = parseRepeat(repetition); } catch (_) { return null; }
        if (!config) return null;
        return (config.sectors || [config]).map((config,index)=><g key={`${axis}-${index}`} data-axis={axis} data-mode="repeat">
          {[["area", config.area, "#9333ea"], ["tile", config.tile, "#16a34a"]].map(([kind, range, fill]) =>
            <rect key={kind} data-repeat={kind}
              x={axis === "x" ? range[0] * 100 : 0} y={axis === "y" ? (1 - range[1]) * 100 : 0}
              width={axis === "x" ? (range[1] - range[0]) * 100 : 100}
              height={axis === "y" ? (range[1] - range[0]) * 100 : 100}
              fill={fill} fillOpacity={kind === "tile" ? .25 : .08} stroke={fill} strokeWidth="1.5"
              strokeDasharray={kind === "area" ? "6 3" : undefined} vectorEffect="non-scaling-stroke" />)}
          <path d={axis === "x" ? `M${(config.area[0]+config.area[1])*50} 0V100` : `M0 ${100-(config.area[0]+config.area[1])*50}H100`}
            fill="none" stroke="#9333ea" strokeWidth="1" strokeDasharray="2 3" vectorEffect="non-scaling-stroke" />
        </g>);
      }
      let profile;
      try { profile = parseStretch(spec); } catch (_) { return null; }
      const ranges=profile.intervals || (profile.interval?[profile.interval]:[]);
      const positions = profile.points || ranges.flat();
      return <g key={axis} data-axis={axis}>
        {ranges.map(([a,b])=><rect key={a} fill={color} fillOpacity="0.2"
          x={axis === "x" ? a * 100 : 0}
          y={axis === "y" ? (1-b) * 100 : 0}
          width={axis === "x" ? (b-a) * 100 : 100}
          height={axis === "y" ? (b-a) * 100 : 100} />)}
        {positions.map((p) => {
          // SVG is top-down; vertical stretch positions are measured from the bottom.
          const path = axis === "x" ? `M${p * 100} 0V100` : `M0 ${(1 - p) * 100}H100`;
          return <g key={p}>
            <path d={path} fill="none" stroke="white" strokeOpacity="0.85" strokeWidth="3" vectorEffect="non-scaling-stroke" />
            <path d={path} fill="none" stroke={color} strokeWidth="1.5" strokeDasharray="6 3" vectorEffect="non-scaling-stroke" />
          </g>;
        })}
      </g>;
    })}
  </svg>;
}
